import React, { Component } from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import BorderedButton from '../../../components/BorderedButton';
const { colors } = themes;

interface ContainerProps {
  mobile?: boolean;
  active?: boolean;
}

const Container = styled.div`
  display: flex;
  min-height: 140px;
  width: 100%;
  transition: all 400ms ease 0s;
  ${({ mobile, active }: ContainerProps) => `
    flex-direction: ${mobile ? 'column' : 'row'};
    z-index: ${active ? 1 : 0};
    box-shadow: ${active ? '0 5px 12px 0 rgba(0, 0, 0, 0.4)' : '0 5px 12px 0 rgba(0, 0, 0, 0.2)'};
    height: ${mobile ? '100%' : 'auto'};
  `};
`;

interface TitleBoxProps {
  mobile?: boolean;
  requiresMembership?: boolean;
  hasMembership?: boolean;
}
const TitleBox = styled.div`
  position: relative;
  ${({ mobile, requiresMembership, hasMembership }: TitleBoxProps) => `
    min-width: ${mobile ? '100%' : '192px'};
    max-width: ${mobile ? '100%' : '200px'};
    min-height: ${mobile ? '132px' : '100%'};
    background-color: ${requiresMembership && !hasMembership ? colors.KBGrey : colors.KBTan};
  `};
`;

interface TitleContentProps {
  mobile?: boolean;
}

const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  ${({ mobile }: TitleContentProps) => `
    padding: ${mobile ? '20px' : '24px'};
    padding-top: ${mobile ? '20px' : '24px'};
  `};
`;

const Title = styled.div`
  z-index: 1;
  ${themes.fonts.DomaineDisplay};
  font-size: 24px;
  color: ${colors.KBNight};
  padding-bottom: 8px;
`;

const Price = styled.div`
  z-index: 1;
  ${themes.fonts.FoundersGrotesk};
  font-size: 16px;
  color: ${colors.KBNight};
  font-weight: bold;
`;

interface HoverOverlayProps {
  hover?: boolean;
  selected?: boolean;
  mobile?: boolean;
}

const HoverOverlay = styled.div`
  background-color: ${colors.KBYellow};
  position: absolute;
  top: 0;
  z-index: 0;
  transition: all 200ms ease 200ms;
  ${({ hover, selected, mobile }: HoverOverlayProps) => {
    if (mobile) {
      let height = '0px';
      if (hover) height = '4px';
      if (selected) height = '100%';
      return `
        height: ${height};
        width: 100%;
      `;
    } else {
      let width = '0px';
      if (hover) width = '4px';
      if (selected) width = '100%';
      return `
        width: ${width};
        height: 100%;
      `;
    }
  }};
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  height: 100%;
`;

const DescriptionText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${colors.KBNight};
  margin-bottom: 18px;
`;

type Props = {
  description: string;
  hasMembership: boolean;
  hover: boolean;
  mobileLayout: boolean;
  name: string;
  onSelect: () => void;
  price: string;
  requiresMembership: boolean;
  selected: boolean;
};

type State = {
  hovered: boolean;
};

export default class AppointmentListCard extends Component<Props, State> {
  static defaultProps: Props = {
    description: '',
    hasMembership: false,
    hover: false,
    mobileLayout: false,
    name: '',
    onSelect: () => {},
    price: '',
    requiresMembership: false,
    selected: false
  };

  state = {
    hovered: false
  };

  renderPrice() {
    const { requiresMembership, hasMembership, price } = this.props;
    if (requiresMembership && !hasMembership) {
      return <MembersOnly />;
    } else if (requiresMembership && hasMembership) {
      // Don't show price for members
      return null;
    } else {
      return <Price>{price}</Price>;
    }
  }

  render() {
    const {
      description,
      hasMembership,
      mobileLayout,
      name,
      requiresMembership,
      selected
    } = this.props;
    return (
      <Container
        onMouseEnter={() => this.setState({ hovered: true })}
        onMouseLeave={() => this.setState({ hovered: false })}
        active={this.state.hovered}
        mobile={mobileLayout}
        onClick={this.props.onSelect}
      >
        <TitleBox
          mobile={mobileLayout}
          requiresMembership={requiresMembership}
          hasMembership={hasMembership}
        >
          <HoverOverlay hover={this.state.hovered} selected={selected} mobile={mobileLayout} />
          <TitleContent>
            <Title>{name}</Title>
            {/*
            https://app.asana.com/0/779820497800777/1156462897837965
            {this.renderPrice()} */}
          </TitleContent>
        </TitleBox>
        <DescriptionContainer>
          <DescriptionText>{description}</DescriptionText>
          {mobileLayout ? (
            <BorderedButton
              text={'SELECT'}
              onClick={() => {
                console.warn('select');
              }}
            />
          ) : null}
        </DescriptionContainer>
      </Container>
    );
  }
}

const MembersOnlyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  width: 130px;
  background-color: ${themes.colors.KBTwilightLight};
`;

const MembersOnlyText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  color: white;
`;

const MembersOnly = () => {
  return (
    <MembersOnlyContainer>
      <MembersOnlyText>MEMBERS ONLY</MembersOnlyText>
    </MembersOnlyContainer>
  );
};
